import { render, staticRenderFns } from "./networkError.vue?vue&type=template&id=72796c39&scoped=true&"
import script from "./networkError.vue?vue&type=script&lang=js&"
export * from "./networkError.vue?vue&type=script&lang=js&"
import style0 from "./networkError.vue?vue&type=style&index=0&id=72796c39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72796c39",
  null
  
)

export default component.exports